import React from 'react';
import { Movie } from '../../types/Movie';
import { User } from '../../services/authService';
import MovieCard from './MovieCard';
import './MovieList.css';

interface MovieListProps {
  movies: Movie[];
  loading: boolean;
  error: string | null;
  user: User | null;
  onEditMovie: (movie: Movie) => void;
  onDeleteMovie: (id: string) => void;
}

const MovieList: React.FC<MovieListProps> = ({ 
  movies, 
  loading, 
  error, 
  user, 
  onEditMovie, 
  onDeleteMovie 
}) => {
  if (loading) {
    return (
      <div className="movie-list-container">
        <div className="movie-list-main">
          <div className="loading-state">
            <h2>🎬 Loading movies...</h2>
            <div className="loading-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="movie-list-container">
        <div className="movie-list-main">
          <div className="error-state">
            <h2>❌ Error loading movies</h2>
            <p>{error}</p>
            <button onClick={() => window.location.reload()}>Retry</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="movie-list-container">
      <div className="movie-list-main">
        <div className="movies-header-condensed">
          <div className="header-row">
            <div className="header-info">
              <h2>My Movies</h2>
              <span className="movie-count">({movies.length} movies)</span>
            </div>
          </div>
        </div>

        <div className="movies-grid">
          {movies.length === 0 ? (
            <div className="empty-state">
              <p>No movies found. Add your first movie to get started!</p>
            </div>
          ) : (
            movies.map(movie => (
              <MovieCard
                key={movie.id}
                movie={movie}
                user={user}
                onEdit={onEditMovie}
                onDelete={onDeleteMovie}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default MovieList;

